import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26c14c84"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "MyEventsItem-intro-title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "MyEventsItem-image" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "MyEventsItem-imageMask" }, [
    /*#__PURE__*/_createElementVNode("picture", { class: "MyEventsItem-imageImg --bottle" }, [
      /*#__PURE__*/_createElementVNode("source", { srcset: "/dev/practical/bottle-my-events.png 1x, /dev/practical/bottle-my-events@2x.png 2x" }),
      /*#__PURE__*/_createElementVNode("img", {
        src: "/dev/practical/bottle-my-events.png",
        alt: "practical bottle"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("picture", { class: "MyEventsItem-imageImg --glass" }, [
    /*#__PURE__*/_createElementVNode("source", { srcset: "/dev/practical/glass-my-events.png 1x, /dev/practical/glass-my-events@2x.png 2x" }),
    /*#__PURE__*/_createElementVNode("img", {
      src: "/dev/practical/glass-my-events.png",
      alt: "practical bottle"
    })
  ])
], -1))
const _hoisted_4 = { class: "MyEventsItem-infos" }
const _hoisted_5 = { class: "MyEventsItem-infosDate" }
const _hoisted_6 = { class: "MyEventsItem-infosHover" }
const _hoisted_7 = { class: "MyEventsItem-infosPlace" }
const _hoisted_8 = { class: "MyEventsItem-infosTime" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppearObject = _resolveComponent("AppearObject")!
  const _component_EventsDate = _resolveComponent("EventsDate")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    to: `/events/${_ctx.id}`,
    class: "MyEventsItem"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_AppearObject, { class: "MyEventsItem-intro" }, {
        default: _withCtx(() => [
          _createElementVNode("p", {
            class: "small-uppercase",
            innerHTML: _ctx.$t('dashboard.myevents_description')
          }, null, 8, _hoisted_1),
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.name), 1),
          _hoisted_3
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_EventsDate, { date: _ctx.startDate }, null, 8, ["date"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.place), 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", null, _toDisplayString(_ctx.formattedTime), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.timezone), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}